import * as actionTypes from "./actionTypes";

const inventoryReducer = (state = [], payload) => {
  switch (payload.type) {
    case actionTypes.ADD_PHYSICAL_INVENTORY_SUCCESS:
      return [...payload.captureGoodsResponse];
    case actionTypes.ADD_PHYSICAL_INVENTORY_MANUAL_RX_SUCCESS:
      return [...payload.physicalInventoryData];
    case actionTypes.ADD_PHYSICAL_INVENTORY_MANUAL_RX_WITHOUT_LOT_NO_SUCCESS:
      return [...payload.physicalInventoryData];
    case actionTypes.ADD_PHYSICAL_INVENTORY_OTC_SUCCESS:
      return [...payload.captureGoodsResponse];
    case actionTypes.ADD_PHYSICAL_INVENTORY_RX_SUCCESS:
      return [...payload.captureGoodsResponse];
    case actionTypes.ADD_OTC_PRODUCT_SUCCESS:
      return [...payload.captureGoodsResponse];
    case actionTypes.ADD_RX_PRODUCT_SUCCESS:
      return [...payload.captureGoodsResponse];
    case actionTypes.ADD_OTC_MANUAL_PRODUCT_SUCCESS:
      return [...payload.captureGoodsResponse];
    case actionTypes.ADD_PHYSICAL_INVENTORY_OTC_RX_WITHOUT_LOT_NO_SUCCESS:
      return [...payload.captureGoodsResponse];

    default:
      return state;
  }
};

export default inventoryReducer;
